<div class="main">
    <div class="container">
        <div class="tab-property tab-scrollX" role="tabpanel" id="create-new-fund">
            <div class="tab-pane in active">
                <div class="row">
                    <div class="createProduct">
                        <div class="createProduct__inner">
                            <div class="row">
                                <div class="col-12 mb-4" *ngIf="!sipName">
                                    <div class="row">
                                        <div class="col-3">
                                            <h4>CCQ chuyển đổi</h4>
                                        </div>
                                        <div class="col-9">
                                            <h4><strong>{{name}}</strong></h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 mb-4" >
                                    <div class="row">
                                        <div class="col-3">
                                            <h4>Chương trình chuyển đổi</h4>
                                        </div>
                                        <div class="col-9">
                                            <h4><strong>{{selectedProgram?.name || 'Linh hoạt'}}</strong></h4>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 mb-4">
                                    <div class="row">
                                        <div class="col-3">
                                            <h4>Chứng chỉ quỹ mục tiêu</h4>
                                        </div>
                                        <div class="col-9">
                                            <select class="form-control" [(ngModel)]="destProduct" title="Chứng chỉ quỹ mục tiêu" (ngModelChange)="chooseProduct()">
                                                <option [value]="undefined" selected>Chọn chứng chỉ quỹ mục tiêu</option>
                                                <option *ngFor="let item of products" [ngValue]="item">{{item.code}} - {{item.name}}</option>
                                            </select>
                                            <span class="error-text" *ngIf="isSaved && !destProduct">
                                                Vui lòng chọn quỹ mục tiêu
                                            </span>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-12 mb-4">
                                    <div class="row">
                                        <div class="col-3">
                                            <h4>Chương trình quỹ mục tiêu</h4>
                                        </div>
                                        <div class="col-9">
                                            <select class="form-control" [(ngModel)]="destProgramId" title="Chương trình quỹ mục tiêu" 
                                                (ngModelChange)="chooseProduct()" disabled>
                                                <option [value]="undefined" selected>Chọn chương trình quỹ mục tiêu</option>
                                                <option *ngFor="let item of programs" [ngValue]="item.schemeId">{{item.scheme?.code}} - {{item.scheme?.name}}</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-12 m-t-30" style="width: 1000px"  [hidden]="!destProgram">
                                    <div class="" [hidden]="!destProduct">
                                        <app-edit-fee [feeList]="fees" [relationalOperators]="relationalOperators" [isValidated]="isSaved"
                                            [boardcast]="TRANSFER_FEE" [isUnitConfig]="true"  [unitValue]="'MONTH'">
                                        </app-edit-fee>
                                        <div class="row"  style="float: right" *ngIf="!isChildren">
                                            <div class="col-12">
                                                <button  class="btn btn-ok btn-delete_fee" style="margin-right: 20px;" (click)="confirmDelete()"><i nz-icon
                                                    nzType="sync" nzTheme="outline"></i><span
                                                    style="margin-left: 5px;">Xóa</span></button>
                                                <button  class="btn btn-ok btn--green" (click)="save()"><i nz-icon
                                                    nzType="sync" nzTheme="outline"></i><span
                                                    style="margin-left: 5px;">Lưu lại</span></button>
                                            </div>
                                        </div>
                                    </div>
                                  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>